<script lang="ts">
	let { children, class: className = '' } = $props();
</script>

<section class="p-4 sm:py-4 md:p-4 {className}">
	{@render children()}
</section>
